export const IS_DEV = process.env.NODE_ENV === 'development';
export const DEV_HOST = 'platform-api.nicecode.biz';
export const PORT = 3000;
export const HOST_NAME = 'localhost';
export const JS_FILE_OUTPUT = 'js/[name].[contenthash].js';
export const JS_CHUNK_OUTPUT = 'js/[name].chunk.bundle.js';
export const CSS_FILE_OUTPUT = 'css/[name].[contenthash].css';
export const CSS_CHUNK_OUTPUT = 'css/[id].[contenthash].css';
export const STATIC_FILE_OUTPUT = 'static/[hash][ext][query]';
export const SENTRY_AUTH_TOKEN = 'sntrys_69c262e832ec11ef8ff20242ac160005';
export const REACT_APP_SENTRY_URL =
  'https://63c2d94724e74ac3b46b24fccc7e18d0@sentry.nicecode.biz/2';
